<template>
  <div>
    <!-- 顶部导航 -->
    <!-- <van-nav-bar
      :title="activeTitle"
      fixed
      placeholder
    /> -->
    <div class="router-view">
      <transition
        name="fade-transform"
        mode="out-in"
      >
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    activeTitle() {
      const activeTitle = this.$route.meta.title;

      return activeTitle;
    }
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
